import { AudienceRolesStorage } from './audience-roles-storage';
import { AudienceRolesSelectComponent } from './audience-roles-select.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CovanceSelectModule } from '../../covance-select/covance-select.module';

@NgModule({
    declarations: [
        AudienceRolesSelectComponent,
    ],
    imports: [
        CommonModule,
        CovanceSelectModule,
    ],
    exports: [
        AudienceRolesSelectComponent,
    ],
    providers: [
        AudienceRolesStorage,
    ],
})
export class AdminFormFieldsModule { }